import jsVectorMap from 'jsvectormap';
require('../../js/us-aea-en.min.js');

const STATE_NAMES = {
    'US-AL': 'Alabama', 'US-AK': 'Alaska', 'US-AZ': 'Arizona', 'US-AR': 'Arkansas',
    'US-CA': 'California', 'US-CO': 'Colorado', 'US-CT': 'Connecticut', 'US-DE': 'Delaware',
    'US-FL': 'Florida', 'US-GA': 'Georgia', 'US-HI': 'Hawaii', 'US-ID': 'Idaho',
    'US-IL': 'Illinois', 'US-IN': 'Indiana', 'US-IA': 'Iowa', 'US-KS': 'Kansas',
    'US-KY': 'Kentucky', 'US-LA': 'Louisiana', 'US-ME': 'Maine', 'US-MD': 'Maryland',
    'US-MA': 'Massachusetts', 'US-MI': 'Michigan', 'US-MN': 'Minnesota', 'US-MS': 'Mississippi',
    'US-MO': 'Missouri', 'US-MT': 'Montana', 'US-NE': 'Nebraska', 'US-NV': 'Nevada',
    'US-NH': 'New Hampshire', 'US-NJ': 'New Jersey', 'US-NM': 'New Mexico', 'US-NY': 'New York',
    'US-NC': 'North Carolina', 'US-ND': 'North Dakota', 'US-OH': 'Ohio', 'US-OK': 'Oklahoma',
    'US-OR': 'Oregon', 'US-PA': 'Pennsylvania', 'US-RI': 'Rhode Island', 'US-SC': 'South Carolina',
    'US-SD': 'South Dakota', 'US-TN': 'Tennessee', 'US-TX': 'Texas', 'US-UT': 'Utah',
    'US-VT': 'Vermont', 'US-VA': 'Virginia', 'US-WA': 'Washington', 'US-WV': 'West Virginia',
    'US-WI': 'Wisconsin', 'US-WY': 'Wyoming', 'US-DC': 'Washington D.C.',
};

const stateName = (code) => STATE_NAMES[code] || code.replace('US-', '');

export function WholesalerMapBlock() {
    const mapEls = document.querySelectorAll('[data-wholesaler-map]');

    if (!mapEls.length) return;

    document.addEventListener('hide.bs.modal', (e) => {
        if (document.activeElement && e.target.contains(document.activeElement)) {
            document.activeElement.blur();
        }
    }, true);

    mapEls.forEach((el) => {
        const wholesalerMap    = JSON.parse(el.dataset.wholesalerMap || '{}');
        const modalId          = el.dataset.modalId || '';
        const modalEl          = modalId ? document.getElementById(modalId) : null;
        const stateSelect      = document.querySelector(`[data-wholesaler-select="${el.id}"]`) || null;

        const ASSIGNED_HOVER_COLOR   = '#0372b5';
        const UNASSIGNED_HOVER_COLOR = '#B6C0CB';
        const DEFAULT_COLOR          = '#c0c8cf';

        const assignedStates = new Set(Object.keys(wholesalerMap));

        let activeCode = null;
        let mapInstance = null;

        const baseColor  = () => DEFAULT_COLOR;
        const hoverColor = (code) => assignedStates.has(code) ? ASSIGNED_HOVER_COLOR : UNASSIGNED_HOVER_COLOR;

        const setRegionColor = (code, color) => {
            const region = mapInstance?.regions[code];
            if (region?.element) region.element.setStyle('fill', color);
        };

        const showModal = () => {
            if (modalEl && window.bootstrap) {
                window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
            }
        };

        const clearActiveState = () => {
            if (!activeCode) return;
            setRegionColor(activeCode, baseColor(activeCode));
            activeCode = null;
            if (stateSelect) stateSelect.value = '';
        };


        const activateState = (code) => {
            if (!mapInstance) return;
        
            if (activeCode && activeCode !== code) {
                setRegionColor(activeCode, baseColor(activeCode));
            }
        
            if (activeCode === code) {
                activeCode = null;
                return;
            }
        
            activeCode = code;
            setRegionColor(code, hoverColor(code));
            if (stateSelect) stateSelect.value = code;
        
            if (modalEl && window.bootstrap) {
                const indices = wholesalerMap[code];
                if (!indices || !indices.length) return;
        
                modalEl.querySelectorAll('.wholesaler-panel').forEach((p) => { p.hidden = true; });
                indices.forEach((idx) => {
                    const panel = modalEl.querySelector(`.wholesaler-panel[data-wholesaler-index="${idx}"]`);
                    if (panel) panel.hidden = false;
                });


                // Add/remove class based on number of wholesalers
                if (indices.length > 1) {
                    modalEl.classList.add('multiple');
                } else {
                    modalEl.classList.remove('multiple');
                }

            
                // Dispatch custom event with the selected state code
                document.dispatchEvent(new CustomEvent('wholesalerStateSelected', {
                    detail: { state: code }
                }));
            
                showModal();
            }
        };

        if (modalEl) {
            modalEl.addEventListener('click', (e) => {
                if (!e.target.closest('.map-modal__cta')) return;
                const salesModalEl = document.querySelector('#salesModal');
                if (salesModalEl && window.bootstrap) {
                    setTimeout(() => window.bootstrap.Modal.getOrCreateInstance(salesModalEl).show(), 400);
                }
            });

            modalEl.addEventListener('hidden.bs.modal', () => {
                clearActiveState();
            });
        }

        mapInstance = new jsVectorMap({
            selector: `#${el.id}`,
            map: 'us_aea_en',
            backgroundColor: 'transparent',
            regionStyle: {
                initial: { fill: DEFAULT_COLOR, stroke: '#ffffff', strokeWidth: 0.5 },
                hover:   { cursor: 'pointer', fillOpacity: 1 },
            },
            showTooltip: true,
            onRegionTooltipShow(event, tooltip, code) {
                tooltip.text(stateName(code));
            },
            onRegionClick(event, code) {
                if (!assignedStates.has(code)) return;
                if (activeCode === code) { showModal(); return; }
                activateState(code);
            },
            markers: [],
            zoomOnScroll: false,
            zoomButtons: false,
        });

        window.addEventListener('resize', () => mapInstance.updateSize());

        document.addEventListener('click', (e) => {
            if (!activeCode) return;
            if (el.contains(e.target)) return;
            if (modalEl?.contains(e.target)) return;
            clearActiveState();
        });

        // Dropdown
        if (stateSelect) {
            stateSelect.addEventListener('change', () => {
                const code = stateSelect.value;
                if (!code) { clearActiveState(); return; }
                if (activeCode === code) activeCode = null;
                activateState(code);
            });
        }

        // Keyboard accessibility + tooltip positioning
        const tooltipEl = document.querySelector('.jvm-tooltip');
        Object.keys(mapInstance.regions).forEach((code) => {
            const region = mapInstance.regions[code];
            if (!region?.element?.shape) return;
            const node  = region.element.shape.node;
            const label = stateName(code);
            const isAssigned = assignedStates.has(code);

            node.style.cursor = isAssigned ? 'pointer' : 'default';
            if (isAssigned) {
                node.setAttribute('tabindex', '0');
                node.setAttribute('role', 'button');
                node.setAttribute('aria-label', label);
            }

            node.addEventListener('focus', () => {
                if (!tooltipEl) return;
                const rect    = node.getBoundingClientRect();
                const tipRect = tooltipEl.getBoundingClientRect();
                tooltipEl.textContent = label;
                tooltipEl.classList.add('active');
                tooltipEl.style.left = `${rect.left + rect.width / 2 - tipRect.width / 2 + window.scrollX}px`;
                tooltipEl.style.top  = `${rect.top - tipRect.height - 8 + window.scrollY}px`;
            });
            node.addEventListener('blur',    () => tooltipEl?.classList.remove('active'));
            node.addEventListener('mouseenter', () => {
                if (isAssigned) setRegionColor(code, hoverColor(code));
            });
            node.addEventListener('mouseleave', () => {
                setRegionColor(code, activeCode === code ? hoverColor(code) : baseColor(code));
            });
            node.addEventListener('keydown', (e) => {
                if (!isAssigned) return;
                if (e.key !== 'Enter' && e.key !== ' ') return;
                e.preventDefault();
                activeCode === code ? showModal() : activateState(code);
            });
        });
    });
}

// Single delegated handler for all .btn-contact-wholesaler clicks across all blocks
(function initContactWholesalerEmail() {
    function setGfEmail(email) {
        const field = document.querySelector('.form-email-hidden .ginput_container_email input');
        if (!field) return;
        field.value = email;
        field.dispatchEvent(new Event('change', { bubbles: true }));
    }

    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.btn-contact-wholesaler');
        if (!btn) return;
        // button carries data-email directly (wholesaler block) or inherits from .wholesaler-panel (map block)
        const source = btn.hasAttribute('data-email') ? btn : btn.closest('[data-email]');
        const email = source ? (source.dataset.email || '') : '';
        setGfEmail(email);
        setTimeout(() => setGfEmail(email), 350);
    });
}());
